module.exports = __webpack_public_path__ + "img/swiper-3.afdd7cde.jpg";